/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseListMeterCatalogItemDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseMeterCatalogDiffResponse } from '../backend/model';
// @ts-ignore
import type { ApiResponseMeterCatalogItemDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseMeterCatalogSnapshotDTO } from '../backend/model';
// @ts-ignore
import type { MeterCatalogDiffRequest } from '../backend/model';
// @ts-ignore
import type { MeterInfoBrandRequest } from '../backend/model';
// @ts-ignore
import type { MeterInfoHardwareRequest } from '../backend/model';
/**
 * MeterCatalogControllerApi - axios parameter creator
 * @export
 */
export const MeterCatalogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: async (meterInfoBrandRequest: MeterInfoBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meterInfoBrandRequest' is not null or undefined
            assertParamExists('createBrand', 'meterInfoBrandRequest', meterInfoBrandRequest)
            const localVarPath = `/api/v1/meter-catalog/admin/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meterInfoBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHardware: async (meterInfoHardwareRequest: MeterInfoHardwareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meterInfoHardwareRequest' is not null or undefined
            assertParamExists('createHardware', 'meterInfoHardwareRequest', meterInfoHardwareRequest)
            const localVarPath = `/api/v1/meter-catalog/admin/hardware`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meterInfoHardwareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateBrand: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateBrand', 'id', id)
            const localVarPath = `/api/v1/meter-catalog/admin/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateHardware: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateHardware', 'id', id)
            const localVarPath = `/api/v1/meter-catalog/admin/hardware/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MeterCatalogDiffRequest} meterCatalogDiffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diff: async (meterCatalogDiffRequest: MeterCatalogDiffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meterCatalogDiffRequest' is not null or undefined
            assertParamExists('diff', 'meterCatalogDiffRequest', meterCatalogDiffRequest)
            const localVarPath = `/api/v1/meter-catalog/diff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meterCatalogDiffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ListBrandsScopeEnum} [scope] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBrands: async (scope?: ListBrandsScopeEnum, councilCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meter-catalog/admin/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (councilCode !== undefined) {
                localVarQueryParameter['councilCode'] = councilCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ListHardwareScopeEnum} [scope] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHardware: async (scope?: ListHardwareScopeEnum, councilCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meter-catalog/admin/hardware`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (councilCode !== undefined) {
                localVarQueryParameter['councilCode'] = councilCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} councilCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshot: async (councilCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilCode' is not null or undefined
            assertParamExists('snapshot', 'councilCode', councilCode)
            const localVarPath = `/api/v1/meter-catalog/snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (councilCode !== undefined) {
                localVarQueryParameter['councilCode'] = councilCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: async (id: number, meterInfoBrandRequest: MeterInfoBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBrand', 'id', id)
            // verify required parameter 'meterInfoBrandRequest' is not null or undefined
            assertParamExists('updateBrand', 'meterInfoBrandRequest', meterInfoBrandRequest)
            const localVarPath = `/api/v1/meter-catalog/admin/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meterInfoBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHardware: async (id: number, meterInfoHardwareRequest: MeterInfoHardwareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHardware', 'id', id)
            // verify required parameter 'meterInfoHardwareRequest' is not null or undefined
            assertParamExists('updateHardware', 'meterInfoHardwareRequest', meterInfoHardwareRequest)
            const localVarPath = `/api/v1/meter-catalog/admin/hardware/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meterInfoHardwareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeterCatalogControllerApi - functional programming interface
 * @export
 */
export const MeterCatalogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeterCatalogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrand(meterInfoBrandRequest: MeterInfoBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBrand(meterInfoBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.createBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHardware(meterInfoHardwareRequest: MeterInfoHardwareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHardware(meterInfoHardwareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.createHardware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateBrand(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.deactivateBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateHardware(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateHardware(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.deactivateHardware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MeterCatalogDiffRequest} meterCatalogDiffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diff(meterCatalogDiffRequest: MeterCatalogDiffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogDiffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diff(meterCatalogDiffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.diff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ListBrandsScopeEnum} [scope] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBrands(scope?: ListBrandsScopeEnum, councilCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBrands(scope, councilCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.listBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ListHardwareScopeEnum} [scope] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHardware(scope?: ListHardwareScopeEnum, councilCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHardware(scope, councilCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.listHardware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} councilCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshot(councilCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogSnapshotDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshot(councilCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.snapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrand(id: number, meterInfoBrandRequest: MeterInfoBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrand(id, meterInfoBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.updateBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHardware(id: number, meterInfoHardwareRequest: MeterInfoHardwareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMeterCatalogItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHardware(id, meterInfoHardwareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeterCatalogControllerApi.updateHardware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeterCatalogControllerApi - factory interface
 * @export
 */
export const MeterCatalogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeterCatalogControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand(meterInfoBrandRequest: MeterInfoBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogItemDTO> {
            return localVarFp.createBrand(meterInfoBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHardware(meterInfoHardwareRequest: MeterInfoHardwareRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogItemDTO> {
            return localVarFp.createHardware(meterInfoHardwareRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateBrand(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogItemDTO> {
            return localVarFp.deactivateBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateHardware(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogItemDTO> {
            return localVarFp.deactivateHardware(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MeterCatalogDiffRequest} meterCatalogDiffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diff(meterCatalogDiffRequest: MeterCatalogDiffRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogDiffResponse> {
            return localVarFp.diff(meterCatalogDiffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ListBrandsScopeEnum} [scope] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBrands(scope?: ListBrandsScopeEnum, councilCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListMeterCatalogItemDTO> {
            return localVarFp.listBrands(scope, councilCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ListHardwareScopeEnum} [scope] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHardware(scope?: ListHardwareScopeEnum, councilCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListMeterCatalogItemDTO> {
            return localVarFp.listHardware(scope, councilCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} councilCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshot(councilCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogSnapshotDTO> {
            return localVarFp.snapshot(councilCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand(id: number, meterInfoBrandRequest: MeterInfoBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogItemDTO> {
            return localVarFp.updateBrand(id, meterInfoBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHardware(id: number, meterInfoHardwareRequest: MeterInfoHardwareRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMeterCatalogItemDTO> {
            return localVarFp.updateHardware(id, meterInfoHardwareRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeterCatalogControllerApi - object-oriented interface
 * @export
 * @class MeterCatalogControllerApi
 * @extends {BaseAPI}
 */
export class MeterCatalogControllerApi extends BaseAPI {
    /**
     * 
     * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public createBrand(meterInfoBrandRequest: MeterInfoBrandRequest, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).createBrand(meterInfoBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public createHardware(meterInfoHardwareRequest: MeterInfoHardwareRequest, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).createHardware(meterInfoHardwareRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public deactivateBrand(id: number, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).deactivateBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public deactivateHardware(id: number, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).deactivateHardware(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MeterCatalogDiffRequest} meterCatalogDiffRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public diff(meterCatalogDiffRequest: MeterCatalogDiffRequest, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).diff(meterCatalogDiffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ListBrandsScopeEnum} [scope] 
     * @param {string} [councilCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public listBrands(scope?: ListBrandsScopeEnum, councilCode?: string, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).listBrands(scope, councilCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ListHardwareScopeEnum} [scope] 
     * @param {string} [councilCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public listHardware(scope?: ListHardwareScopeEnum, councilCode?: string, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).listHardware(scope, councilCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} councilCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public snapshot(councilCode: string, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).snapshot(councilCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {MeterInfoBrandRequest} meterInfoBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public updateBrand(id: number, meterInfoBrandRequest: MeterInfoBrandRequest, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).updateBrand(id, meterInfoBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {MeterInfoHardwareRequest} meterInfoHardwareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeterCatalogControllerApi
     */
    public updateHardware(id: number, meterInfoHardwareRequest: MeterInfoHardwareRequest, options?: RawAxiosRequestConfig) {
        return MeterCatalogControllerApiFp(this.configuration).updateHardware(id, meterInfoHardwareRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListBrandsScopeEnum = {
    Global: 'GLOBAL',
    Council: 'COUNCIL'
} as const;
export type ListBrandsScopeEnum = typeof ListBrandsScopeEnum[keyof typeof ListBrandsScopeEnum];
/**
 * @export
 */
export const ListHardwareScopeEnum = {
    Global: 'GLOBAL',
    Council: 'COUNCIL'
} as const;
export type ListHardwareScopeEnum = typeof ListHardwareScopeEnum[keyof typeof ListHardwareScopeEnum];
